import { Box } from '@mui/material';
import { FC } from 'react';
import { Nullable } from 'common-types';
import { filterNoneOnlyFilters } from '../../common/filters-utils/filters-utils';
import FiltersFormContainer from '../../elements/FiltersForm/FiltersForm';
import config from '../config/pipeline-summary-config.json';
import FilterBox from '../../elements/FilterBox/FilterBox';
import FilterSearch from '../../elements/FilterFormItem/FilterSearch';
import { handleSearchFilterType } from '../store/pipeline-summary-filters-store-actions';
import { onChangeFilter } from '../actions/pipeline-summary-filters-actions';
import { FilterPipelineSummaryType } from '../pipeline-summary-types';
import { pipelineSummaryFilters } from '../pipeline-summary-utils';

const PipelineSummarySidebar: FC<
  React.PropsWithChildren<PipelineSideBarProps>
> = ({
  pipelineFiltersType,
  pipelineFiltersTypeSearch,
  filterList,
  total,
  children,
  disabled,
  searchValues,
  handleFilterClear,
}) => {
  return (
    <Box
      ml={2}
      width={config.sidebar.expandedSize}
      display='flex'
      flexDirection='column'
      gap={1.2}>
      {children}
      {pipelineFiltersType &&
        pipelineFiltersTypeSearch &&
        pipelineSummaryFilters.map(
          filter =>
            filterNoneOnlyFilters(pipelineFiltersType[filter.type], total) &&
            pipelineFiltersType[filter.type]?.length > 0 && (
              <FilterBox
                key={filter.header}
                header={filter.header}
                handleClear={handleFilterClear}
                type={filter.type}
                filtersNumber={filterList[filter.type]?.length}>
                {filter.searchType && (
                  <FilterSearch
                    searchValue={searchValues[filter.type]}
                    onSearch={handleSearchFilterType}
                    filterType={filter.searchType}
                  />
                )}
                <FiltersFormContainer
                  filterByList={pipelineFiltersTypeSearch[filter.type]}
                  filterTypeToFilterBy={filter.type}
                  onChangeFilter={onChangeFilter}
                  filterList={filterList}
                  itemHeight={config.filters.itemHeight}
                  maxHeight={config.filters.maxHeight}
                  disabled={disabled}
                />
              </FilterBox>
            ),
        )}
    </Box>
  );
};

export interface PipelineSideBarProps {
  disabled?: boolean;
  filterList: {};
  pipelineFiltersType: Nullable<FilterPipelineSummaryType>;
  pipelineFiltersTypeSearch: Nullable<FilterPipelineSummaryType>;
  total: number;
  searchValues: {};
  handleFilterClear: (type: string) => void;
}

export default PipelineSummarySidebar;
